import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icon';
import styles from './ContentType.module.less';
import clsx from 'clsx';

export const typeDisplayMap = {
  worksheet: 'Worksheet',
  game: 'Game',
  song: 'Song',
  story: 'Story',
  'guided-lesson': 'Guided Lesson',
  'lesson-plan': 'Lesson Plan',
  activity: 'Activity',
  article: 'Article',
  'skill-builder': 'Exercise',
  workbook: 'Workbook',
  slideshow: 'Slideshow',
  'science-fair': 'Science Project',
  predefinedCollection: 'Snackpack',
};

const ContentType = ({ isPremium, isEL, isInteractive, type, withinGrid = false, inHoverSection = false }) => {
  const iconSvgAnimated = (
    <img src="/files/static/interactive-worksheets/icons/sparkles-icon-purple.svg"/>
  );

  return (
    <div
      className={clsx(
        styles.contentTypeHolder,
        { [styles.grid]: withinGrid },
        { [styles.interactive]: isInteractive },
        { [styles.inHoverSection]: inHoverSection})}
    >
      {isPremium && (
        <div
          className={clsx(styles.contentTypeIcon, styles.premium)}
          title="This content is for premium members"
        >
          <Icon name="diamond" />
        </div>
      )}
      {isEL && (
        <div
          className={clsx(styles.contentTypeIcon, styles.el)}
          title="This content has support for English Learners"
        >
          <Icon name="el" />
        </div>
      )}{' '}
      {isInteractive && (
        <div
          className={clsx(styles.contentTypeIcon, styles.interactive)}
          title="This worksheet is interactive"
        >
          {iconSvgAnimated}
        </div>
      )}
      <div className={styles.contentTypeName}>{isInteractive ? 'Interactive Worksheet' : typeDisplayMap[type]}</div>
    </div>
  );
};
ContentType.displayName = 'ContentType';
ContentType.propTypes = {
  isPremium: PropTypes.bool.isRequired,
  isEL: PropTypes.bool,
  isInteractive: PropTypes.bool,
  type: PropTypes.oneOf(Object.keys(typeDisplayMap)).isRequired,
  withinGrid: PropTypes.bool,
  inHoverSection: PropTypes.bool
};

export default ContentType;
